"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MarkdownTextarea;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Input = require("./Input");

var _Mentions = _interopRequireDefault(require("./Mentions"));

var _mentionInputStyle = require("../../styles/mentionInputStyle");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ResizeWrapper = ( /*#__PURE__*/0, _styledBase.default)('div', {
  target: "ex41iml0",
  label: "ResizeWrapper"
})("textarea{", function (props) {
  return props.resize === false ? 'resize: none;' : null;
}, "}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2Zvcm0vaW5wdXRzL01hcmtkb3duVGV4dGFyZWEuanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU9tQyIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9mb3JtL2lucHV0cy9NYXJrZG93blRleHRhcmVhLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XHJcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcclxuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcclxuaW1wb3J0IHsgVGV4dGFyZWEgfSBmcm9tICcuL0lucHV0JztcclxuaW1wb3J0IE1lbnRpb25zIGZyb20gJy4vTWVudGlvbnMnO1xyXG5pbXBvcnQgeyB3aXRob3V0UmVwbHlGb3JtU3R5bGUgfSBmcm9tICcuLi8uLi9zdHlsZXMvbWVudGlvbklucHV0U3R5bGUnO1xyXG5cclxuY29uc3QgUmVzaXplV3JhcHBlciA9IHN0eWxlZCgnZGl2JylgXHJcbiAgdGV4dGFyZWEge1xyXG4gICAgJHtwcm9wcyA9PiAocHJvcHMucmVzaXplID09PSBmYWxzZSA/ICdyZXNpemU6IG5vbmU7JyA6IG51bGwpfVxyXG4gIH1cclxuYDtcclxuXHJcbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIE1hcmtkb3duVGV4dGFyZWEocHJvcHMpIHtcclxuICBjb25zdCB7IG5hbWUsIG91dGRhdGVkLCByZXNpemUsIC4uLnJlc3QgfSA9IHByb3BzO1xyXG5cclxuICByZXR1cm4gKFxyXG4gICAgPFJlc2l6ZVdyYXBwZXIgcmVzaXplPXtyZXNpemV9PlxyXG4gICAgICB7b3V0ZGF0ZWQgPyAoXHJcbiAgICAgICAgPFRleHRhcmVhIGF1dG9Gb2N1cyB7Li4ucmVzdH0gaWQ9e25hbWV9IG5hbWU9e25hbWV9IC8+XHJcbiAgICAgICkgOiAoXHJcbiAgICAgICAgPE1lbnRpb25zIGF1dG9Gb2N1cyB7Li4ucmVzdH0gbmFtZT17bmFtZX0gc3R5bGU9e3dpdGhvdXRSZXBseUZvcm1TdHlsZX0gLz5cclxuICAgICAgKX1cclxuICAgIDwvUmVzaXplV3JhcHBlcj5cclxuICApXHJcbn1cclxuXHJcbk1hcmtkb3duVGV4dGFyZWEucHJvcFR5cGVzID0ge1xyXG4gIG5hbWU6IFByb3BUeXBlcy5zdHJpbmcsXHJcbiAgcmVzaXplOiBQcm9wVHlwZXMuc3RyaW5nLFxyXG4gIG91dGRhdGVkOiBQcm9wVHlwZXMuYm9vbFxyXG59O1xyXG5cclxuTWFya2Rvd25UZXh0YXJlYS5kZWZhdWx0UHJvcHMgPSB7XHJcbiAgbmFtZTogJycsXHJcbiAgcmVzaXplOiBcImZhbHNlXCIsXHJcbiAgb3V0ZGF0ZWQ6IGZhbHNlXHJcbn07XHJcbiJdfQ== */"));

function MarkdownTextarea(props) {
  var name = props.name,
      outdated = props.outdated,
      resize = props.resize,
      rest = _objectWithoutProperties(props, ["name", "outdated", "resize"]);

  return /*#__PURE__*/_react.default.createElement(ResizeWrapper, {
    resize: resize
  }, outdated ? /*#__PURE__*/_react.default.createElement(_Input.Textarea, _extends({
    autoFocus: true
  }, rest, {
    id: name,
    name: name
  })) : /*#__PURE__*/_react.default.createElement(_Mentions.default, _extends({
    autoFocus: true
  }, rest, {
    name: name,
    style: _mentionInputStyle.withoutReplyFormStyle
  })));
}

MarkdownTextarea.propTypes = {
  name: _propTypes.default.string,
  resize: _propTypes.default.string,
  outdated: _propTypes.default.bool
};
MarkdownTextarea.defaultProps = {
  name: '',
  resize: "false",
  outdated: false
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/form/inputs/MarkdownTextarea.js
// module id = 349
// module chunks = 0 15 16 17 18